<template>
    <v-layout row>
        <v-flex xs12>
            <v-stepper v-model="e1">
                <v-stepper-header>
                    <v-stepper-step :complete="e1 > 1" step="1">CPC</v-stepper-step>
                        <v-divider></v-divider>
                    <v-stepper-step :complete="e1 > 2" step="2">Facturar</v-stepper-step>
                        <!-- <v-divider></v-divider>
                    <v-stepper-step step="3">Confirmar</v-stepper-step> -->
                </v-stepper-header>

                <v-stepper-items>
                    <v-stepper-content step="1">
                        <v-card class="mb-5 elevation-0" height="200px">
                            <v-form v-on:submit.prevent="validarCpc" ref="formcpc" v-model="validcpc" lazy-validation>
                                <v-layout justify-center>
                                    <v-flex xs12 sm6 md4 lg2 align-center justify-center>
                                        <v-text-field
                                            ref="cpc"
                                            @change="validarCpc"
                                            v-model="form.cpc"
                                            prepend-icon="featured_video"
                                            label="Ingresa el CPC"
                                            :rules="[v => !!v || 'CPC es requerido']"
                                            :error-messages="errCpc"
                                            required
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-card>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn :loading="loading" color="primary" @click="validarCpc">Siguiente</v-btn>
                        </v-card-actions>
                    </v-stepper-content>

                    <v-stepper-content step="2">
                      <v-card class="mb-5 elevation-0">
                           <v-container grid-list-xl>
                          <v-form ref="formconceptos" v-model="validconceptos" lazy-validation @submit.prevent="">
                              <v-layout wrap row>
                                <v-flex xs12 sm6 md4>

                                    <v-card v-if="e1 == 2">
                                        <v-toolbar :color="total_deuda > 0 ? 'red' : 'cyan'" dark>
                                            <v-toolbar-title>{{ total_deuda > 0 ? `SALDO DEUDOR ${new Intl.NumberFormat("de-DE").format(parseFloat(total_deuda).toFixedDown(2))} Bs` : SOLVENTE }}</v-toolbar-title>
                                            <v-spacer></v-spacer>
                                        </v-toolbar>
                                    </v-card>

                                    </v-flex>
                                    <v-flex xs12 sm6 md8 align-center justify-center>
                                        <v-autocomplete
                                            :filter="customFilter"
                                            v-model="form.concepts"
                                            :disabled="isUpdating"
                                            :items="filterConceptsSelect"
                                            :rules="[v => this.form.concepts_old > 0 ? true : v.length > 0 || 'Seleccione un concepto']"
                                            chips
                                            color="blue-grey lighten-2"
                                            label="Conceptos"
                                            item-text="name"
                                            item-value="id"
                                            multiple
                                            autofocus
                                            return-object
                                        >
                                            <template v-slot:selection="data">
                                                <v-chip
                                                    :selected="data.selected"
                                                    close
                                                    class="chip--select-multi"
                                                    @input="remove(data.item)"
                                                >
                                                {{ data.item.code }}
                                                </v-chip>
                                            </template>
                                            <template v-slot:item="data">
                                                <v-list-tile-content>
                                                    <v-list-tile-title v-html="data.item.code + ' - ' +data.item.name"></v-list-tile-title>
                                                </v-list-tile-content>
                                            </template>
                                        </v-autocomplete>
                                        <!-- <v-data-table
                                            :items="form.concepts_old"
                                            class="elevation-0"
                                            hide-actions
                                            no-data-text=""
                                        >
                                            <template v-slot:items="props">
                                                <td>1</td>
                                                <td>{{ props.item.mes }}/{{ props.item.year }}, Trimestre: {{ props.item.trimestre }} {{ props.item.concepto }}</td>
                                                <td class="text-xs-right">{{ props.item.amount == null ? 0 : props.item.amount }}</td>
                                            </template>
                                        </v-data-table> -->
                                        <v-data-table
                                            :items="form.concepts"
                                            class="elevation-0"
                                            hide-actions
                                            hide-headers
                                            no-data-text=""
                                        >
                                            <template v-slot:items="props">
                                                <td><vue-numeric-input :value="form.concepts[props.index].qty" :min="1" :max="parseInt(props.item.concept_cost_last_amount.sales_limit)" @change="changeQty($event,props.item)" size="50px" align="center" controls-type="updown"></vue-numeric-input></td>
                                                <td>{{ props.item.name }}</td>
                                                <td class="text-xs-right">{{ props.item.concept_cost_last_amount == null ? 0 : props.item.concept_cost_last_amount.amount }} X {{ props.item.qty }}</td>
                                            </template>
                                            <template v-slot:footer>
                                                <tr>
                                                    <td colspan="2">
                                                        <strong>Sub-Total</strong>
                                                    </td>
                                                    <td class="text-xs-right">
                                                        <strong>{{ parseFloat(subTotalCostConcepts).toFixedDown(2) }}</strong>
                                                    </td>
                                                </tr>
                                                <tr v-for="(index, imp) in filterTaxConcepts" :key="imp">
                                                    <td colspan="2">
                                                        <strong>{{ imp }}</strong>
                                                    </td>
                                                    <td class="text-xs-right">
                                                        <strong>{{ index.length == 0 ? 0 : parseFloat(index).toFixedDown(2) }}</strong>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td colspan="2">
                                                        <strong>Total</strong>
                                                    </td>
                                                    <td class="text-xs-right">
                                                        <strong>{{ parseFloat(totalCostConcepts).toFixedDown(2) }}</strong>
                                                    </td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-container>
                      </v-card>
                        <v-card-actions>
                            <v-btn color="primary darken-1" @click="backToSearchCpc">Atras</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" @click="confirmData">FACTURAR</v-btn>
                            <!-- <v-btn color="primary" @click="setDataConcepts">FACTURAR</v-btn> -->
                            <v-btn flat @click="backToSearchCpc">ELIMINAR</v-btn>
                        </v-card-actions>
                    </v-stepper-content>

                    <!-- <v-stepper-content step="3">
                        <v-card class="mb-5 elevation-0">
                            <v-form ref="formpago" v-model="validpago" lazy-validation>
                                <v-layout justify-center>
                                    <v-flex xs12 sm6 md6 lg4 align-center justify-center>
                                        <v-text-field
                                            ref="rif"
                                            v-model="form.rif"
                                            prepend-icon="receipt"
                                            label="RIF"
                                            :rules="[v => !!v || 'RIF es requerido']"
                                            required
                                        ></v-text-field>
                                        <v-text-field
                                            ref="razonsocial"
                                            v-model="form.razon_social"
                                            prepend-icon="receipt"
                                            label="Razon social"
                                            :rules="[v => !!v || 'Razon social es requerido']"
                                            required
                                        ></v-text-field>
                                        <v-text-field
                                            ref="direccionfiscal"
                                            v-model="form.direccion_fiscal"
                                            prepend-icon="receipt"
                                            label="Direccion Fiscal"
                                            :rules="[v => !!v || 'Direccion Fiscal es requerido']"
                                            required
                                        ></v-text-field>
                                        <v-select
                                            prepend-icon="account_balance_wallet"
                                            :items="wayToPay"
                                            v-model="form.way_to_pay"
                                            @change="changeWayToPay"
                                            label="Método de pago"
                                            :rules="[v => !!v || 'Método de pago es requerido']"
                                            required
                                        ></v-select>
                                        <v-select
                                            v-if="form.way_to_pay == 'PUNTO ELECTRONICO' || form.way_to_pay == 'TRANSFERENCIA'"
                                            prepend-icon="account_balance"
                                            :items="banks"
                                            v-model="form.bank_id"
                                            item-text="name"
                                            item-value="id"
                                            label="Banco"
                                            :rules="[v => !!v || 'Método de pago es requerido']"
                                            required
                                        ></v-select>
                                        <v-select
                                            prepend-icon="credit_card"
                                            v-if="form.way_to_pay == 'PUNTO ELECTRONICO'"
                                            :items="electronicPoint"
                                            v-model="form.electronic_point_id"
                                            label="Punto electrónico"
                                            item-text="name"
                                            item-value="id"
                                            :rules="[v => !!v || 'Punto electrónico es requerido']"
                                            required
                                        ></v-select>
                                        <v-text-field
                                            v-if="form.way_to_pay == 'PUNTO ELECTRONICO' || form.way_to_pay == 'TRANSFERENCIA'"
                                            ref="number"
                                            v-model="form.number"
                                            prepend-icon="receipt"
                                            label="Número de transacción"
                                            :rules="[v => !!v || 'Número de transacción es requerido']"
                                            required
                                        ></v-text-field>
                                        <v-flex xs12>
                                            <v-menu
                                                ref="menu"
                                                lazy
                                                :close-on-content-click="false"
                                                v-model="menu"
                                                transition="scale-transition"
                                                offset-y
                                                full-width
                                                :nudge-right="40"
                                                min-width="290px"
                                                :return-value.sync="date"
                                            >
                                                <v-text-field
                                                slot="activator"
                                                label="Fecha"
                                                v-model="computedDateFormattedFecha"
                                                hint="DD/MM/YYYY formato"
                                                prepend-icon="event"
                                                :rules="[v => !!v || 'Fecha es requerido']"
                                                required
                                                readonly
                                                ></v-text-field>
                                                <v-date-picker v-model="form.payment_date" no-title scrollable>
                                                <v-spacer></v-spacer>
                                                <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                                                <v-btn flat color="primary" @click="$refs.menu.save(date)">OK</v-btn>
                                                </v-date-picker>
                                            </v-menu>
                                        </v-flex>
                                        <v-textarea
                                            prepend-icon="reorder"
                                            v-model="form.observations"
                                            auto-grow
                                            color="primary"
                                            label="Observación"
                                            rows="2"
                                        ></v-textarea>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-card>
                        <v-card-actions>
                            <v-btn color="primary darken-1" @click="backToConceptos">Atras</v-btn>
                            <v-spacer></v-spacer>
                            <v-btn :loading="loading" color="primary" @click="confirmData">Procesar</v-btn>
                            <v-btn flat @click="backToSearchCpc">ELIMINAR</v-btn>
                        </v-card-actions>
                    </v-stepper-content> -->
                </v-stepper-items>
            </v-stepper>
        </v-flex>
          <v-layout row justify-center>
            <v-dialog v-model="print" persistent max-width="800px">
                <v-card>
                    <v-card-title>
                        <span class="headline">Factura</span>
                    </v-card-title>
                    <v-card-text>
                        <FacturaPago :data="dataFactura" v-if="print"/>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn color="primary darken-1" @click="closePay">Cerrar</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn :loading="loading" color="primary darken-1" flat v-print="'#printMe'">Imprimir Factura</v-btn>
                        <!-- <v-btn color="primary darken-1" flat>Troquelar</v-btn> -->
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-layout>
    </v-layout>
</template>

<script>
import axios from 'axios'
import Form from 'vform'
import { mapGetters } from 'vuex'
import VueNumericInput from 'vue-numeric-input'
import FacturaPago from '~/components/factura/FacturaPago.vue'

Number.prototype.toFixedDown = function(digits) {
    var re = new RegExp("(\\d+\\.\\d{" + digits + "})(\\d)"),
        m = this.toString().match(re);
    return m ? parseFloat(m[1]) : this.valueOf();
};

export default {

    name: 'pagos-view',

    components: {
        VueNumericInput,
        FacturaPago
    },

    computed: {

        ...mapGetters({
            existCPC: 'existCPC',
            agremiado: 'getAgremiadoData',
            total_deuda: 'getTotalDeuda',
            conceptsServices: 'conceptsServices',
            banks: 'getAllBanks',
            print: 'printFacturaPay',
            dataFactura: 'dataFacturaPay',
            electronicPoint: 'getElectronicPoints'
        }),

        filterConceptsSelect () {
            return this.conceptsServices.filter(c => c.id != 9 && c.id != 13)
        },

        totalCostConcepts () {
            let sumaImpuestos = 0
            let concepts = 0
            let concepts_old = 0

            for(var imp in this.filterTaxConcepts) {
                sumaImpuestos += this.filterTaxConcepts[imp]
            }

            concepts = parseFloat(this.form.concepts.reduce((total, c) => parseFloat(total) + parseFloat(c.concept_cost_last_amount == null ? 0 : (c.concept_cost_last_amount.amount * c.qty)), sumaImpuestos))
            concepts_old = parseFloat(this.form.concepts_old.reduce((total, c) => parseFloat(total) + parseFloat(c.amount == null ? 0 : c.amount), 0))

            return  parseFloat(concepts + concepts_old).toFixedDown(2);
        },

        subTotalCostConcepts () {
            let concepts = 0
            let concepts_old = 0
            concepts = parseFloat(this.form.concepts.reduce((total, c) => parseFloat(total) + parseFloat(c.concept_cost_last_amount == null ? 0 : (c.concept_cost_last_amount.amount * c.qty)), 0))
            concepts_old = parseFloat(this.form.concepts_old.reduce((total, c) => parseFloat(total) + parseFloat(c.amount == null ? 0 : c.amount), 0))

            return  parseFloat(concepts + concepts_old).toFixedDown(2);
        },

        filterTaxConcepts () {
            var esto = this
            let objA = this.form.concepts.map(item => item.concept_tax_last_porcent).reduce(function(groups, item) {
                            for (let index = 0; index < item.length; index++) { //recorro los tax del concepto
                                const val = item[index].code; //codigo concepto
                                let conceptMonto = esto.form.concepts.find(concept => concept.id === item[index].pivot.concept_id) // buscamos el concepto con el mismo id del tax concept id
                                conceptMonto = conceptMonto.concept_cost_last_amount == null ? 0 : (conceptMonto.concept_cost_last_amount.amount * conceptMonto.qty) // multiplicamos el monto por la cantidad de conceptos seleccionados

                                if(groups[val]){ // si existe el tax
                                    let val1 = parseFloat(item[index].amount) / 100 // iva 0.18 example
                                    groups[val] += (parseFloat(conceptMonto) * val1) // suma de impuestos independientemente de los conceptos
                                }else { // de no existir
                                    let val1 = parseFloat(item[index].amount) / 100 // iva 0.18 example
                                    groups[val] = parseFloat(conceptMonto) * val1 || [] // se asigna el primer valor del tax
                                }

                            }

                            return groups
                        }, {})

            let objB = this.form.concepts_old.reduce(function(groups, item) {
                            let cuotaObj = esto.conceptsServices.find(concept => concept.id === 9) // buscamos todo el objeto de cuotas
                            let incrementoObj = esto.conceptsServices.find(concept => concept.id === 13) // buscamos todo el objeto de imcremento

                            if(cuotaObj.id == item.concept_id) {
                                for (let index = 0; index < cuotaObj.concept_tax_last_porcent.length; index++) { // for de conceptos cuota old
                                    const val = cuotaObj.concept_tax_last_porcent[index].code; //codigo concepto
                                    let conceptMonto = item.amount == null ? 0 : parseFloat(item.amount) // monto
                                    if(groups[val]){ // si existe el tax
                                        let val1 = parseFloat(cuotaObj.concept_tax_last_porcent[index].amount) / 100 // iva 0.18 example
                                        groups[val] += (parseFloat(conceptMonto) * val1) // suma de impuestos independientemente de los conceptos
                                    }else { // de no existir
                                        let val1 = parseFloat(cuotaObj.concept_tax_last_porcent[index].amount) / 100 // iva 0.18 example
                                        groups[val] = parseFloat(conceptMonto) * val1 || [] // se asigna el primer valor del tax
                                    }
                                }
                            }else if(incrementoObj.id == item.concept_id) {
                                for (let index = 0; index < incrementoObj.concept_tax_last_porcent.length; index++) { // for de conceptos incremento old
                                    const val = incrementoObj.concept_tax_last_porcent[index].code; //codigo concepto
                                    let conceptMonto = item.amount == null ? 0 : parseFloat(item.amount) // monto
                                    if(groups[val]){ // si existe el tax
                                        let val1 = parseFloat(incrementoObj.concept_tax_last_porcent[index].amount) / 100 // iva 0.18 example
                                        groups[val] += (parseFloat(conceptMonto) * val1) // suma de impuestos independientemente de los conceptos
                                    }else { // de no existir
                                        let val1 = parseFloat(incrementoObj.concept_tax_last_porcent[index].amount) / 100 // iva 0.18 example
                                        groups[val] = parseFloat(conceptMonto) * val1 || [] // se asigna el primer valor del tax
                                    }
                                }
                            }

                            return groups
                        }, {})

            return Object.keys(objA).concat(Object.keys(objB)).reduce(function(obj, k) {
                obj[k] = (objA[k] || 0) + (objB[k] || 0);
                return obj;
            }, {})
        },

        filterTaxConceptsOld () {
            var esto = this
            return this.form.concepts_old.reduce(function(groups, item) {
                let cuotaObj = esto.conceptsServices.find(concept => concept.id === 9) // buscamos todo el objeto de cuotas
                let incrementoObj = esto.conceptsServices.find(concept => concept.id === 13) // buscamos todo el objeto de imcremento

                if(cuotaObj.id == item.concept_id) {
                    for (let index = 0; index < cuotaObj.concept_tax_last_porcent.length; index++) { // for de conceptos cuota old
                        const val = cuotaObj.concept_tax_last_porcent[index].code; //codigo concepto
                        let conceptMonto = item.amount == null ? 0 : parseFloat(item.amount) // monto
                        if(groups[val]){ // si existe el tax
                            let val1 = parseFloat(cuotaObj.concept_tax_last_porcent[index].amount) / 100 // iva 0.18 example
                            groups[val] += (parseFloat(conceptMonto) * val1) // suma de impuestos independientemente de los conceptos
                        }else { // de no existir
                            let val1 = parseFloat(cuotaObj.concept_tax_last_porcent[index].amount) / 100 // iva 0.18 example
                            groups[val] = parseFloat(conceptMonto) * val1 || [] // se asigna el primer valor del tax
                        }
                    }
                }else if(incrementoObj.id == item.concept_id) {
                    for (let index = 0; index < incrementoObj.concept_tax_last_porcent.length; index++) { // for de conceptos incremento old
                        const val = incrementoObj.concept_tax_last_porcent[index].code; //codigo concepto
                        let conceptMonto = item.amount == null ? 0 : parseFloat(item.amount) // monto
                        if(groups[val]){ // si existe el tax
                            let val1 = parseFloat(incrementoObj.concept_tax_last_porcent[index].amount) / 100 // iva 0.18 example
                            groups[val] += (parseFloat(conceptMonto) * val1) // suma de impuestos independientemente de los conceptos
                        }else { // de no existir
                            let val1 = parseFloat(incrementoObj.concept_tax_last_porcent[index].amount) / 100 // iva 0.18 example
                            groups[val] = parseFloat(conceptMonto) * val1 || [] // se asigna el primer valor del tax
                        }
                    }
                }

                return groups
            }, {})
        },

        computedDateFormattedFecha () {
            return this.formatDate(this.form.payment_date)
        },

    },

    watch: {

      isUpdating (val) {
        if (val) {
          setTimeout(() => (this.isUpdating = false), 3000)
        }
      }

    },

    mounted () {
        this.checkAuth()
    },

    data: () => ({
        value: 1,
        e1: 0,
        date: null,
        taxesC: {},
        taxesCOLD: {},
        menu: false,
        loading: false,
        validcpc: false,
        validpago: false,
        validconceptos: false,
        errCpc: [],
        wayToPay: [
            'PUNTO ELECTRONICO',
            'EFECTIVO - MONEDA LOCAL',
            'EFECTIVO - DIVISAS',
            'TRANSFERENCIA'
        ],
        isUpdating: false,
        form: new Form({
            cpc: '',
            concepts: [],
            concepts_old: [],
            imp: [],
            way_to_pay: '',
            electronic_point_id: '',
            number: null,
            payment_date: '',
            observations: '',
            rif: '',
            razon_social: '',
            direccion_fiscal: '',
            agreement: false,
            total: 0,
            sub_total: 0
        })
    }),

    methods: {

        async validarCpc() {
            if (this.$refs.formcpc.validate()) {
                this.loading = true
                await this.$store.dispatch('existCpc', this.form.cpc)
                if(this.existCPC != ''){
                    this.getAllConcepts()
                    this.form.rif = this.agremiado.rif
                    this.form.razon_social = this.agremiado.name
                    this.form.direccion_fiscal = this.agremiado.direccion_fiscal
                    this.e1 = 2
                }
                this.$nextTick(() => {
                    this.loading = false
                })
            }
        },

        async remove (item) {
            const indexL = this.form.concepts.indexOf(item)
            const index = this.conceptsServices.indexOf(item)
            await this.$store.dispatch('setQtyConcept', {event: 1,index: index})
            if (indexL >= 0) this.form.concepts.splice(indexL, 1)
        },

        async changeWayToPay() {
            if(this.form.way_to_pay != 'PUNTO ELECTRONICO'){
                this.form.electronic_point_id = ''
            }
            if(this.form.way_to_pay == 'EFECTIVO - MONEDA LOCAL'){
                this.form.number = null
            }
            if(this.form.way_to_pay == 'EFECTIVO - DIVISAS'){
                this.form.number = null
            }
        },

        async getAllConcepts() {
            await this.$store.dispatch('fetchConceptServices')
        },

        async checkAuth() {
            await this.$store.dispatch('setModalFacturaPay', false)
            await this.$store.dispatch('fetchUser')
        },

        async setDataConcepts() {
            if (this.$refs.formconceptos.validate() || this.form.concepts_old.length > 0) {
                if(this.solvencia.length > 0 && (this.solvencia[0].solvente || this.form.concepts_old.length > 0)){
                    this.loading = true
                    this.form.total = this.totalCostConcepts
                    this.form.sub_total = this.subTotalCostConcepts
                    this.form.rif = this.agremiado.rif
                    this.form.razon_social = this.agremiado.name
                    this.form.direccion_fiscal = this.agremiado.direccion_fiscal
                    await this.$store.dispatch('setConceptServices', this.form.concepts)
                    // await this.$store.dispatch('fetchBanks')
                    // this.e1 = 3
                    // this.$nextTick(() => {
                    //     this.loading = false
                    // })
                }else{
                    this.$store.dispatch('responseMessage', {
                        type: 'error',
                        text: 'El Agremiado debe cancelar su deuda, presione el boton Agregar'
                    })
                }
            }
        },

        customFilter (item, queryText, itemText) {
            const textOne = item.code.toLowerCase()
            const textTwo = item.name.toLowerCase()
            const searchText = queryText.toLowerCase()
            return textOne.indexOf(searchText) > -1 || textTwo.indexOf(searchText) > -1
        },

        formatDate (date) {
            if (!date) return null

            const [year, month, day] = date.split('-')
            return `${day}/${month}/${year}`
        },

        async confirmData () {
            // if (this.$refs.formpago.validate()) {
                if (this.$refs.formconceptos.validate()) {
                    this.loading = true
                    this.form.total = this.totalCostConcepts
                    this.form.sub_total = this.subTotalCostConcepts
                    console.log(this.form)

                    await axios.post(`/api/administration/cobranza/crear-factura-colegio`,this.form)
                                .then(res => {
                                    this.$store.dispatch('responseMessage', {
                                        type: 'success',
                                        text: 'Se ha generado la factura de manera Exitosa!..'
                                    })
                                    this.backToSearchCpc()
                                })
                                .catch(e => {
                                    console.log(e.response)
                                    if (e.response.data.errors) {
                                        if (e.response.data.errors.msg) {
                                            this.$store.dispatch('responseMessage', {
                                                type: 'error',
                                                text: e.response.data.errors.msg
                                            })
                                        }else {
                                            this.$store.dispatch('responseMessage', {
                                                type: 'error',
                                                text: e.response.data.error
                                            })
                                        }
                                    }
                                })
                                .finally(() => this.loading = false);
                    // this.form.rif = this.agremiado.rif
                    // this.form.razon_social = this.agremiado.name
                    // this.form.direccion_fiscal = this.agremiado.direccion_fiscal
                    // await this.$store.dispatch('setConceptServices', this.form.concepts)
                    // await this.$store.dispatch('fetchBanks')
                    // this.e1 = 3
                    // this.$nextTick(() => {
                    //     this.loading = false
                    // })
                }
                // this.form.agreement = confirm('Esta Seguro de procesar el pago?')
                //     if(this.form.agreement){
                //         await this.$store.dispatch('sendPayConfirm', this.form)
                //     }else{
                //         console.log('cancelado el envio')
                //     }
                // this.$nextTick(() => {
                //     this.loading = false
                // })
            // }
        },

        async changeQty (event,item) {
            const index = this.conceptsServices.indexOf(item)
            console.log(index,'index')

            await this.$store.dispatch('setQtyConcept', {event: event,index: index})
        },

        async addLastpay() {
            this.loading = true
            this.$refs.formconceptos.resetValidation()
            this.sostenimiento.forEach(sost => {
                this.form.concepts_old.push(sost)
            });

            this.incremento.forEach(inc => {
                this.form.concepts_old.push(inc)
            });

            console.log(this.form.concepts_old,'list')

            this.$nextTick(() => {
                this.loading = false
            })
        },

        async deleteLastpay() {
            this.loading = true
            this.form.concepts_old = []
            this.$refs.formconceptos.resetValidation()
            this.$nextTick(() => {
                this.loading = false
            })
        },

        backToSearchCpc () {
            this.loading = true
            this.form = new Form({
                cpc: '',
                concepts: [],
                concepts_old: [],
                imp: [],
                way_to_pay: '',
                electronic_point_id: '',
                number: null,
                payment_date: '',
                observations: '',
                agreement: false,
                total: 0,
                sub_total: 0
            })
            this.$refs.formcpc.resetValidation()
            this.$refs.formconceptos.resetValidation()
            this.e1 = 1
            this.$nextTick(() => {
                this.loading = false
            })
        },

        backToConceptos () {
            this.loading = true
            this.e1 = 2
            this.$refs.formconceptos.resetValidation()
            this.$nextTick(() => {
                this.loading = false
            })
        },

        async closePay() {
            this.loading = true
            await this.$store.dispatch('setModalFacturaPay', false)
            this.backToSearchCpc()
            this.$nextTick(() => {
                this.loading = false
            })
        },

    }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/administracion/pagos.vue